import React, { useState, useRef, useEffect } from 'react';
import { isEmpty } from 'lodash';

import './index.module.less';

import { isCubeApp, commandMessage, defaultPoint, isInIos } from '@helpers/Constants';
import NativeInterface from '@helpers/NativeInterface';
import { ShapeType } from './constants';
import Filter from '@helpers/Filter';
import { Api } from '@apis/client';
import Http from '@helpers/Http';
import { getNativeProxySington } from '@helpers/NativeProxy';
import BrowserHistory from '@helpers/BrowserHistory';
import FridayService from '@services/friday';
import { transformToBd09 } from '@utils/mapUtil';

import NavBar from '@components/NavBar';
import { hideLoading, showLoading } from '@widgets/Loading';
import CircleDetail from './CircleDetail';
import PolygonDetail from './PolyognDetail';
import Confirm from './Confirm';
import * as Cache from '../../../../../app/helpers/Cache';
import { GuardItem } from '@apis/gloabal';

const GuardArea = () => {
  const urlParams = useRef(Filter.urlParams(window.location.search));
  const [loading, setLoading] = useState(true);
  const [shape, setShapeType] = useState(0);
  const [editRegion, setEditRegion] = useState(null);
  const [center, setMapCenter] = useState(null);
  const ContentRef = useRef(null);
  const containerComponent = {
    [ShapeType.circle]: CircleDetail,
    [ShapeType.polygon]: PolygonDetail,
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getInitData();
  }, []);

  const getInitData = async () => {
    let centerPoint = defaultPoint;
    //如果是编辑
    if (
      urlParams.current.actionType &&
      urlParams.current.actionType === 'edit'
    ) {
      showLoading();
      let editData = null;
      if (isCubeApp()) {
        const { data } = await NativeInterface.postMessage(
          commandMessage.getCommandData,
          {
            requestCode: 1,
            data: {
              type: 'safeArea',
            },
          },
        );
        editData = data;
        const tempPoints = editData.region.points.map((item: number[]) => transformToBd09({ lng: item[0], lat: item[1] }));
        const tempRegion = {
          ...editData.region,
          points: tempPoints.map((item: { lng: number, lat: number }) => [item.lng, item.lat]),
        };
        const tempPoint = tempRegion.points[0];
        centerPoint = { lng: tempPoint[0], lat: tempPoint[1] };
        let tempShapeType = editData.region.shape;
        setEditRegion(tempRegion);
        setShapeType(tempShapeType);
        setMapCenter(centerPoint);
        setLoading(false);
        hideLoading();
      } else {
        const editData: GuardItem = Cache.get(urlParams.current.uid);
        const tempPoints = editData.region.points.map((item: number[]) => transformToBd09({ lng: item[0], lat: item[1] }));
        const tempRegion = {
          ...editData.region,
          points: tempPoints.map((item: { lng: number, lat: number }) => [item.lng, item.lat])
        };
        const tempPoint = tempRegion.points[0];
        centerPoint = { lng: tempPoint[0], lat: tempPoint[1] };
        let tempShapeType = editData.region.shape;
        setEditRegion(tempRegion);
        setShapeType(tempShapeType);
        setMapCenter(centerPoint);
        setLoading(false);
        hideLoading();
      }
    } else {
      const editData: GuardItem = Cache.get('newGuardArea');
      if(!isEmpty(editData?.region)) {
        const tempPoints = editData.region.points.map((item: number[]) => transformToBd09({ lng: item[0], lat: item[1] }));
        const tempRegion = {
          ...editData.region,
          points: tempPoints.map((item: { lng: number, lat: number }) => [item.lng, item.lat]),
        };
        const tempPoint = tempRegion.points[0];
        centerPoint = transformToBd09({ lng: tempPoint[0], lat: tempPoint[1] });
        let tempShapeType = editData.region.shape;
        setEditRegion(tempRegion);
        setShapeType(tempShapeType);
        setMapCenter(centerPoint);
        setLoading(false);
        hideLoading();
      }else {
        showLoading();
        setShapeType(ShapeType.circle);
        //获取定位信息(如果设备有历史定位，则使用历史定位，没有历史定位时使用默认位置为北京市定位
        const res = await Http.post(Api.GetPositionV1Realtime, {
          snCode: urlParams.current.sncode,
        }).catch(() => {
          setLoading(false);
          hideLoading();
        });
        const result = res ? res.data : null;
        let location = defaultPoint;
        if (result) {
          location = transformToBd09({ lng: result?.longitude, lat: result?.latitude });
        }
        setMapCenter(location);
        setLoading(false);
        hideLoading();
      }
    }
  };

  const confirm = async () => {
    const data = ContentRef.current.save();
    console.log(data, ' datata89')

    let fridayData = null;
    if(data.shape === ShapeType.polygon) {
      fridayData = {
        type: '多边形'
      }
    }else {
      fridayData = {
        type: '圆形',
        radius: data.radius
      }
    }
    FridayService.addEvent('security_guard_add_edit_guard_area_regional_location_save_click', fridayData);
    console.log(JSON.stringify(data), data, 'confirm data');
    if(data) {
      if (isCubeApp()) {
        NativeInterface.postMessage(commandMessage.closeContainer, {
          requestCode: 1,
          data: data,
        });
      } else {
        if (urlParams.current.actionType === 'add') {
          const editData = Cache.get('newGuardArea');
          editData.region = data;
          Cache.save('newGuardArea', editData);
        } else if (urlParams.current.actionType === 'edit') {
          const editData: GuardItem = Cache.get(urlParams.current.uid);
          editData.region = data;
          Cache.save(urlParams.current.uid, editData);
        }

        BrowserHistory.goBack();
        if (isInIos) {
          setTimeout(() => {
            BrowserHistory.goBack();
          });
        }
      }
    }
  };

  const closePage = async () => {
    if(isCubeApp()) {
      const np = await getNativeProxySington('seewoCube');
      await np.asyncInvoke({
        name: 'postMessage',
        params: {
          command: 'command_close_container',
          extras: {},
        },
      });
    }else{
      BrowserHistory.goBack();
      if (isInIos) {
        setTimeout(() => {
          BrowserHistory.goBack();
        });
      }
    }
  };

  const back = async () => {
    if (shape === ShapeType.polygon) {
      const hasData = ContentRef.current.hasData();
      const hasChange = ContentRef.current.hasChange();
      if (hasData && hasChange) {
        return Confirm.show({
          title: '放弃当前编辑内容？',
          text: '放弃后，当前已编辑的区域将被清空。',
          confirmBtnText: '放 弃',
          onConfirm: () => {
            closePage();
          },
        });
      } else {
        closePage();
      }
    } else {
      closePage();
    }
  };

  const changeShapeType = (type: number) => {
    if (shape === ShapeType.polygon) {
      const hasData = ContentRef.current.hasData();
      const tempCenter = ContentRef.current.getMapCenter();
      setMapCenter(tempCenter);
      if (hasData) {
        return Confirm.show({
          title: '放弃当前编辑内容？',
          text: '放弃后，当前已编辑的区域将被清空。',
          confirmBtnText: '放 弃',
          onConfirm: () => {
            setShapeType(type);
            ContentRef.current.reset();
            if(editRegion) {
              setEditRegion(null);
            }
          },
        });
      } else {
        setShapeType(type);
        setEditRegion(null);
      }
    } else if(shape === ShapeType.circle){
      setShapeType(type);
      const tempCenter = ContentRef.current.getMapCenter();
      setMapCenter(tempCenter);
      if(type === ShapeType.polygon) {
        if(editRegion || editRegion?.shape === ShapeType.circle) {
          setEditRegion(null);
        }
      }
    }
  };

  if (loading) {
    return null;
  }

  const Content = containerComponent[shape];
  return (
    <div style={{ width: '100%', height: document.body.clientHeight * 0.65 }}>
      <NavBar
        title=" "
        transparent
        RightBtnComponent={
          <div
            styleName="nav-right-btn"
            className="flex flex-center"
            style={{ background: '#256EFF' }}
            onClick={confirm}
          >
            保存
          </div>
        }
        TitleComponent={
          <div className="flex" styleName="nav-content">
            <div
              className="flex flex-center"
              styleName="nav-content-item"
              onClick={() => changeShapeType(ShapeType.circle)}
            >
              <i
                className="iconfont icon-yuanxingshouhu"
                style={shape === ShapeType.circle ? { color: '#1D70F2' } : {}}
              />
            </div>
            <div
              className="flex flex-center"
              styleName="nav-content-item"
              onClick={() => changeShapeType(ShapeType.polygon)}
            >
              <i
                className="iconfont icon-duobianxingshouhu"
                style={shape === ShapeType.polygon ? { color: '#1D70F2' } : {}}
              />
            </div>
          </div>
        }
        BackBtnComponent={
          <div
            styleName="nav-back-btn"
            className="flex flex-center"
            onClick={back}
          >
            <i className="iconfont icon-tubiaoyanse" />
          </div>
        }
      />
      <Content ref={ContentRef} editData={editRegion} centerPoint={center} urlParams={urlParams.current} />
    </div>
  );
};

export default GuardArea;

//旧版本:
// url: /cube/area?sncode=d0a5c1fh&webviewEnv=app&projectcode=seewo-cube
// 保存时给app传参：
// {
//   longitude: number;
//   latitude: number;
//   address: string;
//   radius: number;
// }

//旧版本编辑时
//url: /cube/area?sncode=d0a5c1fh&webviewEnv=app&projectcode=seewo-cube&position=%7Blat:%2023.181481019188443,%20lng:%20113.4402320226145,%20radius:%20100.01%7D

//如果在新版本新建了多边形的，在旧版查看时：需提示不支持该类型，升级app版本

//新版本使用/guardArea页面
//新建: /cube/guardArea?webviewEnv=app&projectcode=seewo-cube&sncode=1111, 保存时传参：
// {
//   shape: number; //1-圆形, 2-多边形
//   address: string; //区域位置 （圆形：圆心位置， 多边形：多边形守护）
//   points: [        //点坐标数组
//     [111, 222]
//   ];
//   radius?: number;  //圆形的时候才有radius参数
// }